const GA = () => {
  // const [gapiReady, setGapiReady] = useState()
  // const [showGButton, setShowGButton] = useState()

  // var VIEW_ID = '202300998';

  // function loadGoogleApi() {
  //   console.log('started loading g-api')
  //   const script = document.createElement("script");
  //   script.src = "https://apis.google.com/js/client:platform.js";

  //   script.onload = () => {
  //     console.log('onload!')
  //     setGapiReady(true)
  //     setShowGButton(true)
  //   }

  //   document.body.appendChild(script);
  // }

  // function handleGLogin() {
  //   setShowGButton(false)
  //   queryReports()
  // }

  // async function queryReports() {
  //   const data = await window.gapi.client.request({
  //     path: '/v4/reports:batchGet',
  //     root: 'https://analyticsreporting.googleapis.com/',
  //     method: 'POST',
  //     body: {
  //       reportRequests: [
  //         {
  //           viewId: VIEW_ID,
  //           dateRanges: [
  //             {
  //               startDate: '7daysAgo',
  //               endDate: 'today'
  //             }
  //           ],
  //           metrics: [{ expression: "ga:users" }]
  //         }
  //       ]
  //     }
  //   })

  //   console.log(data)
  // }

  // useEffect(() => {
  //   loadGoogleApi()
  // }, [])

  return (
    <>
      'testing ga'
      {/* {showGButton && <GoogleLogin
        clientId="133641952250-6agt77k1cfeu1cohmtkpe261k2tt45hr.apps.googleusercontent.com"
        buttonText="Login"
        onSuccess={handleGLogin}
        // onFailure={responseGoogle}
        scope='https://www.googleapis.com/auth/analytics.readonly'
        cookiePolicy={'single_host_origin'}
      />} */}
    </>
  )
}

export default GA
